import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, Button, Typography } from "@mui/material";

import { uiActions } from "../../../../store/reducers/ui";
import BookingStep from "./BookingStep";
import LitcoTextField from "../../../UI/LitcoTextField";

const generateLawAreasOptions = (handleLawAreaChange) => {
  // const lawAreas = ["Personal Injury", "Wills & Estates", "Real Estate", "Employment", "Other", "I'm not sure"];
  const lawAreas = ["Personal Injury", "Class Action", "Employment", "Other", "Disability", "I'm not sure"];

  const lawAreasOptions = [];

  lawAreas.forEach((lawArea) =>
    lawAreasOptions.push(
      <Grid item xs={6} key={lawArea}>
        <Button value={lawArea} variant="contained" onClick={handleLawAreaChange} fullWidth>
          {lawArea}
        </Button>
      </Grid>
    )
  );

  return lawAreasOptions;
};

export default function LawArea(props) {
  const selectedLawArea = useSelector((state) => state.booking.clientDetails.additionalInfo.lawArea);
  const [lawArea, setLawArea] = useState(selectedLawArea);
  const [lawAreaDetails, setLawAreaDetails] = useState("");
  const dispatch = useDispatch();

  const setSelectedLawArea = (event, newLawArea) => {
    if (!newLawArea && !lawArea) {
      return dispatch(
        uiActions.infoMessage({
          open: true,
          type: "warning",
          message: "Please select area and fill details if required",
        })
      );
    }

    props.onLawAreaSelected(newLawArea || lawArea, lawAreaDetails);
  };

  const handleLawAreaChange = (event) => {
    const newLawArea = event.target.value;

    setLawArea(newLawArea);

    if (newLawArea !== "Other" && newLawArea !== "I'm not sure") {
      setLawAreaDetails("");
      setSelectedLawArea(event, newLawArea);
    }
  };

  const handleLawAreaDetailsChange = (event) => {
    setLawAreaDetails(event.target.value);
  };

  const validDetails = lawArea === "Other" || lawArea === "I'm not sure" ? lawAreaDetails !== "" : true;
  const validInfo = lawArea && validDetails;

  const Actions = () => {
    return (
      <Grid container justifyContent="end">
        <Button color="primary" variant="contained" onClick={setSelectedLawArea} disabled={!validInfo}>
          Next
        </Button>
      </Grid>
    );
  };

  return (
    <BookingStep
      header={"default"}
      subheader={
        <Typography variant="h6" mt={1}>
          What is the area of law?
        </Typography>
      }
      actions={(lawArea === "Other" || lawArea === "I'm not sure") && <Actions />}
      width="450px"
    >
      <Grid container spacing={1}>
        {generateLawAreasOptions(handleLawAreaChange)}
      </Grid>

      {(lawArea === "Other" || lawArea === "I'm not sure") && (
        <LitcoTextField
          xs={12}
          mt={2}
          label="Please provide more details"
          name="description"
          multiline
          rows={4}
          variant="outlined"
          value={lawAreaDetails}
          onChange={handleLawAreaDetailsChange}
          required
        />
      )}
    </BookingStep>
  );
}
